export default {
  state: {
    currentDomain: 'All domains',
    domains: [
      { value: 'all', name: 'All domains', pri: 1 },
      { value: 'Access', name: 'Access (58)', pri: 2 },
      { value: 'Asset', name: 'Asset (23)', pri: 3 },
      { value: 'Audit', name: 'Audit (78)', pri: 4 },
      { value: 'Backup', name: 'Backup (85)', pri: 5 },
      { value: 'BCP', name: 'Business Continuity (35)', pri: 6 },
      { value: 'Capacity', name: 'Capacity (14)', pri: 7 },
      { value: 'Change', name: 'Change (22)', pri: 8 },
      { value: 'Cloud', name: 'Cloud (45)', pri: 9 },
      { value: 'Compliance', name: 'Compliance (78)', pri: 10 },
      { value: 'Configuration', name: 'Configuration (98)', pri: 11 },
      { value: 'Data', name: 'Data (124)', pri: 12 },
      { value: 'Dev', name: 'Development (28)', pri: 13 },
      { value: 'Encryption', name: 'Encryption (75)', pri: 14 },
      { value: 'Endpoint', name: 'Endpoint (65)', pri: 15 },
      { value: 'Finance', name: 'Finance (85)', pri: 16 },
      { value: 'General', name: 'General (20)', pri: 17 },
      { value: 'Governance', name: 'Governance (74)', pri: 18 },
      { value: 'HR', name: 'Human Resources (75)', pri: 19 },
      { value: 'Incident', name: 'Incident (45)', pri: 20 },
      { value: 'Legal', name: 'Legal (85)', pri: 21 },
      { value: 'Logs', name: 'Logs (88)', pri: 22 },
      { value: 'Mobile', name: 'Mobile (44)', pri: 23 },
      { value: 'Network', name: 'Network (57)', pri: 24 },
      { value: 'Operations', name: 'Operations (58)', pri: 25 },
      { value: 'Physical', name: 'Physical (52)', pri: 26 },
      { value: 'Privacy', name: 'Privacy (38)', pri: 27 },
      { value: 'Admin', name: 'Privileges (85)', pri: 28 },
      { value: 'Product', name: 'Product (68)', pri: 29 },
      { value: 'Risk', name: 'Risk (75)', pri: 30 },
      { value: 'Support', name: 'Support (58)', pri: 31 },
      { value: 'Maintenance', name: 'System Maintenance (85)', pri: 32 },
      { value: '3p', name: 'Third Party (135)', pri: 33 },
      { value: 'Threat', name: 'Threat (57)', pri: 34 },
      { value: 'Training', name: 'Training (45)', pri: 35 },
      { value: 'Vulnerability', name: 'Vulnerability (155)', pri: 36 },
      {
        value: 'Web',
        name: 'Web Application (41)',
        pri: 36,
      },
      { value: '-', name: 'Unclassified (235)', pri: 100 },
    ],
  },
  mutations: {
    SET_CURRENT_DOMAIN(state, value) {
      state.currentDomain = value
    },
  },

  getters: {
    GET_CURRENT_DOMAIN(state) {
      return state.currentDomain
    },
    GET_DOMAINS(state) {
      return state.domains
    },
  },
}
